import cntl from "cntl";
import PropTypes from "prop-types";
import { SIZE } from "../constants";
import { useMemo, useState } from "react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

const propTypes = {
  isRight: PropTypes.bool,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md]),
  variant: PropTypes.oneOf(["dark", "light", "black", "white"]),
};

function CarouselArrow({ isRight, size, variant }) {
  const [color, setColor] = useState("");

  const wrapperCn = () => cntl`
    w-fit
    h-fit
    flex
    flex-row
    justify-center
    items-center
    rounded-full
    ${color}
    ${size === SIZE.sm ? "p-2" : "p-2.5"}
    `;

  useMemo(() => {
    switch (variant) {
      case "light":
        setColor("bg-primary-50 text-primary-700");
        break;
      case "dark":
        setColor("bg-primary-700 text-white");
        break;
      case "black":
        setColor("bg-black text-white");
        break;
      case "white":
        setColor("bg-white text-grey-700");
        break;
      default:
        setColor("bg-primary-50 text-primary-700");
        break;
    }
  }, [variant]);

  return (
    <div tabIndex={0} className={wrapperCn()}>
      {isRight ? (
        <IconChevronRight
          className={size === SIZE.sm ? "w-5 h-5" : "w-6 h-6"}
        />
      ) : (
        <IconChevronLeft className={size === SIZE.sm ? "w-5 h-5" : "w-6 h-6"} />
      )}
    </div>
  );
}

CarouselArrow.propTypes = propTypes;
export default CarouselArrow;
